module.exports = "pegasus_template/assets/themelp1/simple/107.png";